import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Banner2.css";
import Banner1 from "../assets/images/banner/banner-01.png";
import Banner2 from "../assets/images/banner/banner-02.png";
import Banner4 from "../assets/images/banner/banner-04.png";
import Banner5 from "../assets/images/banner/banner-05.png";
import Banner6 from "../assets/images/banner/banner-06.png";
import Banner7 from "../assets/images/banner/banner-07.png";
import Logo from "../assets/images/LOGO LAWNET WHITE.png";
export default function Banner() {
  const location = useLocation(); // Get the current route path
  const [selectedBanner, setSelectedBanner] = useState(null);

  useEffect(() => {
    const banners = [Banner1, Banner2, Banner4, Banner5, Banner6, Banner7];

    const randomIndex = Math.floor(Math.random() * banners.length);
    setSelectedBanner(banners[randomIndex]);
  }, [location.pathname]); // Re-run when path changes

  if (!selectedBanner) return null;

  return (
    <div className="banner">
      <img src={selectedBanner} alt="PNMB Banner" loading="lazy" />
      <img
        className="banner-logo"
        src={Logo}
        alt="Lawnet Logo"
        style={{ height: "30px", width: "auto" }}
      />
    </div>
  );
}
